import { TableColumnType } from 'src/types/table';
import { getRowShipperServiceKey } from 'src/utils/shipperServiceFilter';

export const allColumns: TableColumnType[] = [
    {
        label: 'id',
        key: 'ID',
        type: 'number',
    },
    {
        label: 'createdAt',
        key: 'CREATED_AT',
        type: 'dateTime',
    },
    {
        label: 'type',
        key: 'TYPE',
        type: 'select',
        selectOption: 'transportTypeCodes',
    },
    {
        label: 'shipper',
        key: 'SHIPPER',
        type: 'select',
        selectOption: 'shipperCodes',
    },
    {
        label: 'shipperService',
        key: 'SHIPPER_SERVICE_CODE',
        type: 'select',
        selectOption: 'shipperServiceCodes',
        selectOptionKeyFce: (row) => getRowShipperServiceKey(row, 'SHIPPER', 'SHIPPER_SERVICE_CODE'),
    },
    {
        label: 'status',
        key: 'STATUS',
        type: 'select',
        selectOption: 'transportStatusCodes',
        customRender: true,
    },
    {
        label: 'sender',
        key: 'SENDER_NAME',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        label: 'recipient',
        key: 'RECIPIENT_NAME',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    // ID_ITEM hidden for now — linking to order/return will be redesigned later
];
